
import { acfmap } from '../components/maps.js';

export default {
	init() {
		$('.magazine-slider').slick({
      dots: false,
      prevArrow: '<button type="button" class="slider-control slider-control--offset shadow-sm  prev"><i class="icon-arrow-left2"></i></button>',
      nextArrow: '<button type="button" class="slider-control slider-control--offset shadow-sm  next"><i class="icon-arrow-right2"></i></button>',
      infinite: true,
      speed: 300,
    });

    var smoothLinks = document.querySelectorAll('.smooth');
    [].forEach.call(smoothLinks, function(link) {
      var target = link.dataset.target;
      var element = document.getElementById(target);
      link.addEventListener('click', function(){
        element.style.paddingTop = '80px';
        element.scrollIntoView({behavior:'smooth'});
      });
    });


    acfmap();

	},
	finalize() {

	},
}


// WEBPACK FOOTER //
// ./scripts/routes/blog.js